
/***************************************************************/
//                                                  Main Windows
/***************************************************************/
  const textCheckbox = document.querySelector('button[aria-label="Add text"] .StyledCheckbox__Checkbox');
  const logoCheckbox = document.querySelector('button[aria-label="Add logo"] .StyledCheckbox__Checkbox');
  const iconCheckbox = document.querySelector('button[aria-label="Add icon"] .StyledCheckbox__Checkbox');
  const buttonConfirm = document.querySelector('button[aria-label="Confirm"]');

    const buttonConfirmb = document.querySelector('#submitBtn');
  var formIdSpan = document.querySelector('#formIdSpan');
  var formId = formIdSpan.getAttribute('data-form-id');
  console.log("Form ID:", formId); // For debugging purposes

  // Get all buttons
  const buttons = document.querySelectorAll('.EmbroideryOption__ListButton');
  
  // Get all content sections
  const contents = document.querySelectorAll('.EmbroideryOptionSelector__Content');
  
  // Function to hide all content and remove active class
  function hideAllContent() {
      contents.forEach(content => {
          content.classList.remove('active');
      });
  }

  // Function to reset image preview
  function resetPreview() {
    document.querySelector('.EmbroideryPreview__ImageDemo').classList.add('EmbroideryPreview__ImageHide');
    document.querySelector('.EmbroideryPreview__ImageActive').classList.remove('EmbroideryPreview__ImageHide');
    document.querySelector('.TextPreviewItem__Body').classList.remove('PreviewContentHide', 'TextPreviewDemo');
    document.querySelector('.LogoPreviewItem__Container').classList.remove('PreviewContentHide', 'LogoPreviewDemo');
  }
  
  // Add click event listeners to each button
  buttons.forEach(button => {
      button.addEventListener('click', function() {
          // Hide all content first
          hideAllContent();
          
          // Get the button's aria-label to determine which content to show
          const label = this.getAttribute('aria-label');
          
          // Show corresponding content based on button clicked
          switch(label) {
              case 'Add text':
                  document.querySelector('.Text__Content').classList.add('active');
                  document.querySelector('.EmbroideryPreview__ImageDemo').classList.remove('EmbroideryPreview__ImageHide');
                  document.querySelector('.EmbroideryPreview__ImageActive').classList.add('EmbroideryPreview__ImageHide');
              
                  document.querySelector('.LogoPreviewItem__Container').classList.add('PreviewContentHide');
                  document.querySelector('.TextPreviewItem__Body').classList.remove('PreviewContentHide');
                  document.querySelector('.TextPreviewItem__Body').classList.remove('TextPreviewConfirmed');
                  document.querySelector('.TextPreviewItem__Body').classList.add('TextPreviewDemo');
                  break;
              case 'Add icon':
                  document.querySelector('.Icon__Content').classList.add('active');
                  document.querySelector('.EmbroideryPreview__ImageDemo').classList.remove('EmbroideryPreview__ImageHide');
                  document.querySelector('.EmbroideryPreview__ImageActive').classList.add('EmbroideryPreview__ImageHide');
                  document.querySelector('.IconPreviewItem__Body').classList.add('IconPreviewDemo');
              document.querySelector('.IconPreviewItem__Body').classList.remove('PreviewContentHide');
               document.querySelector('.TextPreviewItem__Body').classList.add('PreviewContentHide');
                  document.querySelector('.LogoPreviewItem__Container').classList.add('PreviewContentHide');
                  break;
              case 'Add logo':
                  document.querySelector('.Logo__Content').classList.add('active');
                  document.querySelector('.EmbroideryPreview__ImageDemo').classList.remove('EmbroideryPreview__ImageHide');
                  document.querySelector('.LogoPreviewItem__Container').classList.remove('LogoPreviewConfirmed');
                  
                  document.querySelector('.EmbroideryPreview__ImageActive').classList.add('EmbroideryPreview__ImageHide');
              
                  document.querySelector('.TextPreviewItem__Body').classList.add('PreviewContentHide');
              document.querySelector('.IconPreviewItem__Body').classList.add('PreviewContentHide');
                  document.querySelector('.LogoPreviewItem__Container').classList.remove('PreviewContentHide');
                  document.querySelector('.LogoPreviewItem__Container').classList.add('LogoPreviewDemo');
                  break;
          }
          
      });
  });

  
  
  // Character count update function (since you referenced it)
  function updateCharCount(input) {
      const charCount = input.value.length;
      const maxLength = input.getAttribute('maxlength');
      const counter = input.nextElementSibling;
      counter.textContent = `${charCount}/${maxLength}`;
  $('.IconPreviewItem__Initials').html(input.value);
  }
  
  // Back Button
  const backButtons = document.querySelectorAll('.EmbroideryFormHeader__Button[aria-label="back"]');
  backButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Reset image preview
      resetPreview();
      hideAllContent();
      document.querySelector('.Main__Content').classList.add('active');
         handleTextReset();
// handleIconReset ();
handleLogoReset();
     
    });
  });

  // Radio Buttons
  function setupRadioButtons(name, textSelector, labelSelector, priceSelector) {
    const radios = document.querySelectorAll(`input[name="${name}"]`);
    const textElement = document.querySelector(textSelector);
    const labels = document.querySelectorAll(labelSelector);
    const priceElement = priceSelector ? document.querySelector(priceSelector) : null;
    //const colorTextPreview = document.querySelectorAll(colorPreview);
  
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        textElement.textContent = radio.value;
        labels.forEach(label => label.classList.remove('active'));
        radio.nextElementSibling.classList.add('active');

        //colorTextPreview.setAttribute('data-color', radio.value);

        // Logo Variants Starts Here
        if(radio.getAttribute('name') == 'properties[Logo Color]'){
          let variant__selector = radio.nextElementSibling.getAttribute('data-value');
          let product__input = document.querySelectorAll(`input[data-product="Embroidery Logo"]`);
          let variant__input = document.querySelectorAll(`input[data-title="${variant__selector}"]`);
  
          if (variant__input.length > 0) { // Check if any inputs are found
            product__input.forEach(input => {
              input.setAttribute('form', ''); // Set form id to empty string first
            });
          
            variant__input.forEach(input => {
              input.setAttribute('form', formId); // Now set the actual form id
            });
          }
          
          if (priceElement) {
            const price = radio.getAttribute('data-price');
            priceElement.textContent = price ? price : '';
          }
        }
        // Logo Variants Ends Here

        // Logo Placement Preview Starts
        if(radio.getAttribute('name') == 'properties[Logo Placement]'){
          if(radio.getAttribute('value') == 'Left Chest'){
            document.querySelector('.LogoPreviewItem__Container').classList.remove('right-chest-logo');
            document.querySelector('.LogoPreviewItem__Container').classList.add('left-chest-logo');
          }else{
            document.querySelector('.LogoPreviewItem__Container').classList.remove('left-chest-logo');
            document.querySelector('.LogoPreviewItem__Container').classList.add('right-chest-logo');
          }
        }else if(radio.getAttribute('name') == 'properties[Text Position]'){
          if(radio.getAttribute('value') == 'Left Chest'){
            document.querySelector('.TextPreviewItem__Body').classList.remove('right-chest-text');
            document.querySelector('.TextPreviewItem__Body').classList.add('left-chest-text');
          }else{
            document.querySelector('.TextPreviewItem__Body').classList.remove('left-chest-text');
            document.querySelector('.TextPreviewItem__Body').classList.add('right-chest-text');
          }
        }else if(radio.getAttribute('name') == 'properties[Text Color]'){
          document.querySelector('.TextPreviewItem__Body').setAttribute('data-color', radio.getAttribute('value'))
        }else if(radio.getAttribute('name') == 'properties[Font Type]'){
          document.querySelector('.TextPreviewItem__Body').setAttribute('data-font', radio.getAttribute('value'))
        }
        // Logo Placement Preview Ends
        
      }, { passive: true });
    });
  }
  
  // Initialize for Text Position
  setupRadioButtons(
    'properties[Text Position]',
    '.text__position.shared-form-styles__SelectedOptionText',
    '.shared-form-styles__SelectionButton.btn--text__position'
  );
  
  // Initialize for Text Color
  setupRadioButtons(
    'properties[Text Color]',
    '.text__color.shared-form-styles__SelectedOptionText',
    '.shared-form-styles__SelectionButton.btn--text__color',
  );

  // Initialize for Font Type
  setupRadioButtons(
    'properties[Font Type]',
    '.font__type.shared-form-styles__SelectedOptionText',
    '.shared-form-styles__SelectionButton.btn--font__type'
  );

  // Initialize radio buttons for Icon Selection
  setupRadioButtons(
    'properties[Icon]',
    '.shared-form-styles__SelectedOptionText.icon__selection',
    '.shared-form-styles__SelectionButton.btn--icon__selector'
  );

  // Initialize radio buttons for Initials Color
  setupRadioButtons(
    'properties[Initials Color]',
    '.shared-form-styles__SelectedOptionText.initials__color',
    '.shared-form-styles__SelectionButton.btn--initials__color'
  );

  // Initialize radio buttons for Icon Placement
  setupRadioButtons(
    'properties[Icon Placement]',
    '.shared-form-styles__SelectedOptionText.icon__placement',
    '.shared-form-styles__SelectionButton.btn--icon__placement'
  );

  // Initialize radio buttons for Logo Color
  setupRadioButtons(
    'properties[Logo Color]',
    '.shared-form-styles__SelectedOptionText.logo__color',
    '.shared-form-styles__SelectionButton.btn--logo__color',
    '.price__span'
  );

  // Initialize radio buttons for Logo Placement
  setupRadioButtons(
    'properties[Logo Placement]',
    '.shared-form-styles__SelectedOptionText.logo__placement',
    '.shared-form-styles__SelectionButton.btn--logo__placement'
  );

  /********************************
                    Embroidery Logo
   ********************************/
  // Handle file upload
  const fileInput = document.getElementById('logoUpload');
  const fileNameDisplay = document.querySelector('.EmbroideryFileUpload__FileName');
  
  // fileInput.addEventListener('change', function () {
  //   if (this.files && this.files[0]) {
  //     fileNameDisplay.textContent = this.files[0].name;
   
  //   } else {
  //     fileNameDisplay.textContent = 'No file chosen';
  //   }

  
  // });
  
  // Handle "Use an existing logo" button
  // document.querySelector('.EmbroideryOptionSelector__Button[aria-label="Use an existing logo"]').addEventListener('click', function () {
  //   alert('Redirecting to existing logos...'); // Replace with actual functionality
  // });
  
  // Handle "Login to Continue" button
  // document.querySelector('.EmbroideryOptionSelector__Button--login').addEventListener('click', function () {
  //   alert('Redirecting to login...'); // Replace with actual functionality
  // });


/******************************************************************************
                                                              Reset Button Text
******************************************************************************/
// Get references to elements
const firstLineLabel = document.querySelector('.EmbroideryTextInput__FirstLine');
const firstLineInput = document.querySelector('input[name="properties[First Line]"]');
const textPreviewItem = document.querySelector('.TextPreviewItem__Text');
const textPreviewItemSecond = document.querySelector('.TextPreviewItem__Text--Second');
const secondLineInput = document.querySelector('input[name="properties[Second Line]"]');
const textPositionRadios = document.querySelectorAll('input[name="properties[Text Position]"]');
const textColorRadios = document.querySelectorAll('input[name="properties[Text Color]"]');
const fontTypeRadios = document.querySelectorAll('input[name="properties[Font Type]"]');
const textPositionLabels = document.querySelectorAll('.btn--text__position');
const textColorLabels = document.querySelectorAll('.btn--text__color');
const fontTypeLabels = document.querySelectorAll('.btn--font__type');
const embroideryTextVariant = document.querySelector('#variant-embroidery-text-id');
const textBackButton = document.querySelector('.Button__TextBack');
const textResetButton = document.querySelector('.Button__TextReset');
const textAddButton = document.querySelector('.Button__TextAdd');

// Function to handle the reset
function handleTextReset() {
  // Clear text inputs
  firstLineInput.value = "";
  secondLineInput.value = "";
  textPreviewItem.textContent = "";
  textPreviewItemSecond.textContent = "";

  // Reset character counts
  document.querySelectorAll('.EmbroideryTextInput__CharacterCount').forEach(span => {
    span.textContent = "0/20";
  });

  // Uncheck all radio buttons
  textPositionRadios.forEach(radio => radio.checked = false);
  textColorRadios.forEach(radio => radio.checked = false);
  fontTypeRadios.forEach(radio => radio.checked = false);

  // Remove active class from all labels
  textPositionLabels.forEach(label => label.classList.remove('active'));
  textColorLabels.forEach(label => label.classList.remove('active'));
  fontTypeLabels.forEach(label => label.classList.remove('active'));

  // Add active class to default labels (optional, for better UX)
  document.querySelector('.btn--text__position[for="leftChest"]').classList.add('active');
  document.querySelector('.btn--text__color[for="textblack"]').classList.add('active');
  document.querySelector('.btn--font__type[for="fontblock"]').classList.add('active');

  // Reset selected option text
  document.querySelector('.text__position').textContent = "Left Chest";
  document.querySelector('.text__color').textContent = "Black";
  document.querySelector('.font__type').textContent = "Block";

  document.querySelector('.TextPreviewItem__Body').classList.remove('right-chest-text');
  document.querySelector('.TextPreviewItem__Body').setAttribute('data-color', 'Black');
  document.querySelector('.TextPreviewItem__Body').setAttribute('data-font', 'Block');

  // Reset variant for price
  if (embroideryTextVariant) {
    embroideryTextVariant.setAttribute('form', "");
  }

  textCheckbox.setAttribute('data-checked', 'false');
    $('.text_datacart').attr('data-vid','');
  $('.text_datacart').attr('data-first','');
  $('.text_datacart').attr('data-last','');
  $('.text_datacart').attr('data-position','');
  $('.text_datacart').attr('data-color','');
  $('.text_datacart').attr('data-font','');

}

// textBackButton.addEventListener('click', handleTextReset);
textResetButton.addEventListener('click', handleTextReset);




firstLineInput.addEventListener('input', function() {
  // Update the content of the span element with the input field's value
  textPreviewItem.textContent = firstLineInput.value;
});

secondLineInput.addEventListener('input', function() {
  // Update the content of the span element with the input field's value
  textPreviewItemSecond.textContent = secondLineInput.value;
});
  
/******************************************************************************
                                                              Add Button Text
******************************************************************************/

// Add Button
textAddButton.addEventListener('click', function () {

  // Validate First Line input
  if (!firstLineInput.value.trim()) {
    // Add error class to the First Line label
    firstLineLabel.classList.add('error');
    return; // Stop further execution
  }

  // Remove error class if validation passes
  firstLineLabel.classList.remove('error');

  // Reset image preview
  resetPreview();

  document.querySelector('.LogoPreviewItem__Container').classList.remove('PreviewContentHide');
  document.querySelector('.TextPreviewItem__Body').classList.remove('TextPreviewDemo');
  document.querySelector('.TextPreviewItem__Body').classList.add('TextPreviewConfirmed');

  
  
  // Update checkbox state
  textCheckbox.setAttribute('data-checked', 'true');

  hideAllContent();
  document.querySelector('.Main__Content').classList.add('active');

  // Enable Confirm Button
  buttonConfirm.setAttribute('aria-disabled', 'false');

  // Add Variant for Pricing
  if (embroideryTextVariant) {
    embroideryTextVariant.setAttribute('form', formId);
  }
/* updating text*/
  var firstval = $('.first_input').val();
  var secondval = $('.second_input').val();
  var vId = $(this).attr('data-id');
var pos = $('.btn--text__position.active').attr('data-value');
  var textcolor = $('.btn--text__color.active').attr('data-value');
  var textfont = $('.btn--font__type.active').attr('data-value');
  /* updating values*/
  $('.text_datacart').attr('data-vid',vId);
  $('.text_datacart').attr('data-first',firstval);
  $('.text_datacart').attr('data-last',secondval);
  $('.text_datacart').attr('data-position',pos);
  $('.text_datacart').attr('data-color',textcolor);
  $('.text_datacart').attr('data-font',textfont);


  
});

/******************************************************************************
                                                              Reset Button Icon
******************************************************************************/
// Get references to elements
const initialsInput = document.querySelector('input[name="properties[Initials]"]');
const initialsIconRadios = document.querySelectorAll('input[name="properties[Icon]"]');
const initialsColorRadios = document.querySelectorAll('input[name="properties[Initials Color]"]');
const iconPlacementRadios = document.querySelectorAll('input[name="properties[Icon Placement]"]');
const iconSelectionLabels = document.querySelectorAll('.btn--icon__selector');
const initialsColorLabels = document.querySelectorAll('.btn--initials__color');
const iconPlacementLabels = document.querySelectorAll('.btn--icon__placement');
const embroideryIconVariant = document.querySelector('#variant-embroidery-icon-id');
const iconResetButton = document.querySelector('.Button__IconReset');
const iconBackButton = document.querySelector('.Button__IconBack');
const iconAddButton = document.querySelector('.Button__IconAdd');

// Function to handle the reset
function handleIconReset  () {
  // Clear the initials input
  initialsInput.value = "";

  // Reset the character count
  document.querySelector('.EmbroideryIcon__CharacterCount').textContent = "0/2";

  // Uncheck all radio buttons
  initialsIconRadios.forEach(radio => radio.checked = false);
  initialsColorRadios.forEach(radio => radio.checked = false);
  iconPlacementRadios.forEach(radio => radio.checked = false);

  // Remove active class from all labels
  iconSelectionLabels.forEach(label => label.classList.remove('active'));
  initialsColorLabels.forEach(label => label.classList.remove('active'));
  iconPlacementLabels.forEach(label => label.classList.remove('active'));

  // Add active class to the first label in each group (optional, for better UX)
  function addActiveClassToFirst(labels) {
    if (labels.length > 0) {
      labels[0].classList.add('active');
    }
  }
  
  addActiveClassToFirst(iconSelectionLabels);
  addActiveClassToFirst(initialsColorLabels);
  addActiveClassToFirst(iconPlacementLabels);

  // Reset Subtitle of the Options
  function setTextContentFromLabels(selector, labels) {
    const element = document.querySelector(selector);
    if (element) {
      if (labels.length > 0) {
        element.textContent = labels[0].getAttribute('data-value');
      } else {
        element.textContent = '';
      }
    } else {
      console.error(`Element with selector "${selector}" not found`);
    }
  }
  
  setTextContentFromLabels('.icon__selection', iconSelectionLabels);
  setTextContentFromLabels('.initials__color', initialsColorLabels);
  setTextContentFromLabels('.icon__placement', iconPlacementLabels);

  iconCheckbox.setAttribute('data-checked', 'false');
  document.querySelector('button[aria-label="Add logo"]').removeAttribute('disabled');

     $('.icon_datacart').attr('data-vid','');
  $('.icon_datacart').attr('data-icon','');
  $('.icon_datacart').attr('data-intial','');
  $('.icon_datacart').attr('data-intialcolor','');
   $('.icon_datacart').attr('data-placement','');
$('.IconPreviewItem__Body').removeClass('IconPreviewDemo');
  $('.IconPreviewItem__Body img').removeAttr('src');
    $('.IconPreviewItem__Body span').html('');
  $('.btn--icon__selector IconSelector__IconButton').removeClass('active');
}

// Add event listeners to both buttons
// iconResetButton.addEventListener('click',handleIconReset  );
// iconBackButton.addEventListener('click', handleIconReset  );

  
  


  
/******************************************************************************
                                                               Add Button Icon
******************************************************************************/

// Add Button
iconAddButton.addEventListener('click', function () {
  // Update checkbox state
  iconCheckbox.setAttribute('data-checked', 'true');

  // Disable Logo checkbox
  logoCheckbox.setAttribute('data-checked', 'false');
  document.querySelector('button[aria-label="Add logo"]').setAttribute('disabled', 'true');

  hideAllContent();
  document.querySelector('.Main__Content').classList.add('active');

  // Enable Confirm Button
  buttonConfirm.setAttribute('aria-disabled', 'false');

var iconimg = $('.IconSelector__IconButton.active img').attr('src');
 var intialText = $('.iconintial').val();
  var intialColor = $('.btn--initials__color.active').attr('data-value');
  var iconplace = $('.btn--icon__placement.active').attr('data-value');
  var vid = $(this).attr('data-id');

   $('.icon_datacart').attr('data-vid',vid);
  $('.icon_datacart').attr('data-icon',iconimg);
  $('.icon_datacart').attr('data-intial',intialText);
  $('.icon_datacart').attr('data-intialcolor',intialColor);
   $('.icon_datacart').attr('data-placement',iconplace);

   $('.logo_datacart').attr('data-vid','');
  $('.logo_datacart').attr('data-logocolor','');
  $('.logo_datacart').attr('data-img','');
  $('.logo_datacart').attr('data-logoname','');
  $('.logo_datacart').attr('data-placement','');
  $('.logo_datacart').attr('data-note','');


});



/************************************************************************
                                                              Upload Logo
************************************************************************/
// $(document).on('click','.bte_back1',function(){
//   $('.bte_back2').hide();
// });
$(document).on('click','.bte_back2',function(){

   $('.logo_coloropt').css('display','block');
      $('.content_mesg').show();
      $('.digitation').show();
      $('.bte_back1').show();
      $('.UploadButton__Label').show();
        $('.logo_reset_add').css('display','none');
      $('.cstm_logoplace').css('display','none');
      $('.norm_mesg').css('display','none');
      $('.cstn_value').html('');
      $('.page_val').html('1 / 2');
  $(this).hide();

  
});
  document.getElementById('logoUpload').addEventListener('change', function (event) {
  const file = event.target.files[0]; // Get the selected file
  const previewBox = document.getElementById('previewBox');
  const previewImage = document.getElementById('previewImage');
 // Validate file type
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/postscript']; // EPS = application/postscript
    if (!allowedTypes.includes(file.type)) {
        alert("Only PNG, JPG, or EPS files are allowed.");
        // $('#error-message').text("Only PNG, JPG, or EPS files are allowed.").show();
        return;
    }

    // Validate file size (max 3MB)
    let fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > 3) {
        // $('#error-message').text("File size exceeds 3MB limit!").show();
       alert("File size exceeds 3MB limit!");
        return;
    }

    // Clear previous error
    // $('#error-message').hide().text("");

    // Read file as base64
    let reader = new FileReader();
    reader.onload = function (e) {
        var dataSave = e.target.result;

        if (!dataSave || !dataSave.includes('base64,')) {
            alert("Invalid image data format.");
            return;
        }

        let base64Parts = dataSave.split(';base64,');
        if (base64Parts.length !== 2) {
            alert("Image format is incorrect.");
            return;
        }

        let base64Data = base64Parts[1];
        let contentType = base64Parts[0].split(':')[1];

        // Convert base64 to Blob
        function base64ToBlob(base64, mimeType) {
            let byteCharacters = atob(base64);
            let byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: mimeType });
        }

        let imageBlob = base64ToBlob(base64Data, contentType);
        let formData = new FormData();
        formData.append("image", imageBlob, "upload." + contentType.split('/')[1]);

        // Show loader
        $('#loader').removeClass('hide');

        // Upload to server
        $.ajax({
            url: 'https://gaiarepublic.leapoffaithtech.com//upload.php',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                console.log("Server Response:", response);
                try {
                    let jsonResponse = JSON.parse(response);
                    if (jsonResponse.file_path) {
                        let fullPath = 'https://gaiarepublic.leapoffaithtech.com/' + jsonResponse.file_path;

                        $('#previewImage').attr('src', fullPath);
                        // $('#loader').addClass('hide');
                       previewBox.style.display = 'flex';
                      $('.logo_coloropt').css('display','none');
      $('.content_mesg').hide();
      $('.digitation').hide();
      $('.bte_back1').hide();
      $('.UploadButton__Label').hide();
        $('.logo_reset_add').css('display','flex');
      $('.cstm_logoplace').css('display','block');
      $('.norm_mesg').css('display','block');
      $('.cstn_value').html('<span class="lolg">LOGO</span>'+$('.btn--logo__color.active').html());
      $('.page_val').html('2 / 2');
      $('.bte_back2').show();
                    } else {
                        console.error("Unexpected response format:", response);
                    }
                } catch (e) {
                    console.error("Failed to parse JSON response:", response);
                }
            },
            error: function (xhr, status, error) {
                console.error("AJAX Error:", error);
            }
        });
    };

    reader.readAsDataURL(file);
    
    
});

// Function to clear the preview and reset the file input
function clearPreview() {
  const previewBox = document.getElementById('previewBox');
  const previewImage = document.getElementById('previewImage');
  const fileInput = document.getElementById('logoUpload');

  // Hide the preview box
  previewBox.style.display = 'none';

  // Clear the image preview
  previewImage.src = '';

  // Reset the file input
  fileInput.value = '';
}


/******************************************************************************
                                                              Reset Button Logo
******************************************************************************/

// Get references to elements
const logoNameInput = document.querySelector('input[name="properties[Logo Name]"]');
const logoColorRadios = document.querySelectorAll('input[name="properties[Logo Color]"]');
const logoPlacementRadios = document.querySelectorAll('input[name="properties[Logo Placement]"]');
//const logoUploadInput = document.querySelector('input[name="properties[Logo Upload]"]');
const logoNoteTextarea = document.querySelector('textarea[name="properties[Logo Note]"]');
const embroideryLogoVariant = document.querySelectorAll('input[data-product="Embroidery Logo"]');
const logoColorLabels = document.querySelectorAll('.btn--logo__color');
const logoPlacementLabels = document.querySelectorAll('.btn--logo__placement');
const logoResetButton = document.querySelector('.Button__LogoReset');
const logoBackButton = document.querySelector('.Button__LogoBack');
const logoAddButton = document.querySelector('.Button__LogoAdd');
//const previewBox = document.getElementById('previewBox');
//const previewImage = document.getElementById('previewImage');

// Function to handle the reset for Logo
function handleLogoReset() {
  // Clear the logo name input
  logoNameInput.value = "";

  // Reset the character count for logo name
  document.querySelector('.EmbroideryLogo__CharacterCount').textContent = "0/50";

  document.querySelector('.LogoPreviewItem__Container').classList.remove('right-chest-logo');

  // Uncheck all radio buttons
  logoColorRadios.forEach(radio => radio.checked = false);
  logoPlacementRadios.forEach(radio => radio.checked = false);

  // Clear the logo upload input
  // logoUploadInput.value = "";

  // Clear the logo note textarea
  logoNoteTextarea.value = "";

  // Remove active class from all labels
  logoColorLabels.forEach(label => label.classList.remove('active'));
  logoPlacementLabels.forEach(label => label.classList.remove('active'));

  // Hide the preview box
  clearPreview();
  
  // Reset Basic Price
  document.querySelector('.price__span').textContent = "$100.00";

  // Add active class to the first label in the logo color group (optional, for better UX)
  if (logoColorLabels.length > 0) {
    logoColorLabels[0].classList.add('active');
  }
  if (logoPlacementLabels.length > 0) {
    logoPlacementLabels[0].classList.add('active');
  }

  // Reset selected option text to the first active element in the logo color group
  document.querySelector('.logo__color').textContent = logoColorLabels.length > 0 ? logoColorLabels[0].getAttribute('data-value') : '';
  document.querySelector('.logo__placement').textContent = logoPlacementLabels.length > 0 ? logoPlacementLabels[0].getAttribute('data-value') : '';

  logoCheckbox.setAttribute('data-checked', 'false');

  // Enable Icon Button
  //document.querySelector('button[aria-label="Add icon"]').removeAttribute('disabled');
  if (document.querySelector('button[aria-label="Add icon"]')) {
    document.querySelector('button[aria-label="Add icon"]').removeAttribute('disabled');
  }

  // Reset Variant for Pricing
  /*
  if (embroideryLogoVariant) {
    embroideryLogoVariant.setAttribute('form', '');
  }
  */
  embroideryLogoVariant.forEach(input => {
    input.removeAttribute('form'); // Completely removes the form attribute
  });
  
  $('.logo_datacart').attr('data-vid','');
  $('.logo_datacart').attr('data-logocolor','');
  $('.logo_datacart').attr('data-img','');
  $('.logo_datacart').attr('data-logoname','');
  $('.logo_datacart').attr('data-placement','');
  $('.logo_datacart').attr('data-note','');

   $('.logo_coloropt').css('display','block');
      $('.content_mesg').show();
      $('.digitation').show();
      $('.bte_back1').show();
      $('.UploadButton__Label').show();
        $('.logo_reset_add').css('display','none');
      $('.cstm_logoplace').css('display','none');
      $('.norm_mesg').css('display','none');
      $('.cstn_value').html('');
      $('.page_val').html('1 / 2');
$('.bte_back2').hide();
  
}

// Add event listeners to the reset button
logoResetButton.addEventListener('click', handleLogoReset);

// Optionally, add event listener to the back button if needed
//logoBackButton.addEventListener('click', handleLogoReset);


/******************************************************************************
                                                               Add Button Logo
******************************************************************************/

// Add Button
logoAddButton.addEventListener('click', function () {

  // Optional: Update checkbox state
  logoCheckbox.setAttribute('data-checked', 'true');

  // Disable Logo checkbox
  // iconCheckbox.setAttribute('data-checked', 'false');
  // document.querySelector('button[aria-label="Add icon"]').setAttribute('disabled', 'true');
  if (iconCheckbox) {
    iconCheckbox.setAttribute('data-checked', 'false');
  }
  
  const disableIconButton = document.querySelector('button[aria-label="Add icon"]');
  if (disableIconButton) {
    disableIconButton.setAttribute('disabled', 'true');
  }

  // Reset image preview
  resetPreview();

  document.querySelector('.TextPreviewItem__Body').classList.remove('PreviewContentHide');
  // document.querySelector('.TextPreviewItem__Body').classList.remove('PreviewContentHide');
  document.querySelector('.LogoPreviewItem__Container').classList.remove('LogoPreviewDemo');
  document.querySelector('.LogoPreviewItem__Container').classList.add('LogoPreviewConfirmed');
  
  hideAllContent();
  document.querySelector('.Main__Content').classList.add('active');

  // Enable Confirm Button
  buttonConfirm.setAttribute('aria-disabled', 'false');

  // Add Variant for Pricing



  var lconimg = $('#previewImage').attr('src');
 var logoColor = $('.btn--logo__color.active').attr('data-value');
  var logoName = $('.logo_nme').val();
  var logoplace = $('.btn--logo__placement.active').attr('data-value');
  var note = $('.Note__TextArea').val();
  var vid = $('.btn--logo__color.active').attr('data-id');

   $('.logo_datacart').attr('data-vid',vid);
  $('.logo_datacart').attr('data-logocolor',logoColor);
  $('.logo_datacart').attr('data-img',lconimg);
  $('.logo_datacart').attr('data-logoname',logoName);
  $('.logo_datacart').attr('data-placement',logoplace);
  $('.logo_datacart').attr('data-note',note);



   $('.icon_datacart').attr('data-vid','');
  $('.icon_datacart').attr('data-icon','');
  $('.icon_datacart').attr('data-intial','');
  $('.icon_datacart').attr('data-intialcolor','');
   $('.icon_datacart').attr('data-placement','');

});



document.addEventListener('DOMContentLoaded', function () {
/***************************************************************/
//                                    JavaScript for modal toggle
/***************************************************************/
  const personalizeButton = document.querySelector('.EmbroideryCtaSection__EmbroideryCta');
  const modal = document.querySelector('.EmbroideryModal__Portal');
  const closeButton = document.querySelector('.EmbroideryModalHeader__CloseButton');

  // Open modal on button click
  personalizeButton.addEventListener('click', function () {
    modal.classList.add('EmbroideryModal__Portal--active');
    document.body.classList.add('model__active');
  });

  // Close modal on close button click
  closeButton.addEventListener('click', function () {
    modal.classList.remove('EmbroideryModal__Portal--active');
    document.body.classList.remove('model__active');

    // Reset image preview
    resetPreview();
    
    hideAllContent();
    document.querySelector('.Main__Content').classList.add('active');
    
    try {
        handleTextReset();
        // handleIconReset ();
        handleLogoReset();
    } catch (error) {
        console.error('Reset function error:', error);
    }
  });

  // Close modal on overlay click
  modal.addEventListener('click', function (event) {
    if (event.target === modal.querySelector('.EmbroideryModal__Overlay')) {
      modal.classList.remove('EmbroideryModal__Portal--active');
    }
  });



  
/***************************************************************/
//                                      JavaScript for Logo Note 
/***************************************************************/
  const buttonAccordion = document.getElementById('accordion__button');
  const content = document.getElementById('accordion__content');

  // Set initial height based on aria-expanded
  if (buttonAccordion.getAttribute('aria-expanded') === 'true') {
      content.style.height = `${content.scrollHeight}px`;
  } else {
      content.style.height = '0px';
  }

  // Add click event listener
  buttonAccordion.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Toggle aria-expanded attribute
      this.setAttribute('aria-expanded', !isExpanded);

      if (isExpanded) {
          // Collapse
          content.style.height = `${content.scrollHeight}px`;
          requestAnimationFrame(() => {
              content.style.height = '0px';
          });
      } else {
          // Expand
          content.style.height = `${content.scrollHeight}px`;
          content.addEventListener('transitionend', function handler() {
              content.style.height = 'auto';
              content.removeEventListener('transitionend', handler);
          }, { once: true });
      }

      // Toggle SVG icon between + and -
      const icon = this.querySelector('.Accordion__StyledAccordionHeaderIcon svg');
      if (icon) {
          if (isExpanded) {
              // Change to + icon (collapsed state)
              icon.innerHTML = '<g stroke="#282828" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M6 1.665v8.92M10.335 6h-8.92"></path></g>';
              icon.setAttribute('viewBox', '0 0 12 12');
          } else {
              // Change to - icon (expanded state)
              icon.innerHTML = '<path d="M10.335 1h-8.92" stroke="#282828" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>';
              icon.setAttribute('viewBox', '0 0 12 2');
          }
      }
  });


});
buttonConfirmb.addEventListener('click', function () {
  var items = [];

  // Product name (used in all)
  var pnamek = $('.pnameee').attr('data-name');
  var selectedIdsks = $('.EmbroideryModal__Portal').attr('data-id');
  var prelogo = $(this).attr('data-id');

  console.log(pnamek + '--' + prelogo + '---' + selectedIdsks);

  // First product
  items.push({
    id: selectedIdsks,
    quantity: 1
  });

  var comt = $('#myTextarea').val();

  // Second product with properties
  items.push({
    id: prelogo,
    quantity: 1,
    properties: {
      Customised_Product: pnamek,
      Comment: comt
    }
  });

  // ✅ Use "items" instead of "itemsk"
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => { throw err });
      }
      return response.json();
    })
    .then(data => {
      handleTextReset();
      handleLogoReset();
      console.log('Added to cart:', data);
      location.href = "/cart"; // redirect
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      // alert(error?.description || 'Something went wrong. Please try again.');
    });
});

// Confirm Customizations and Close Modal
buttonConfirm.addEventListener('click', function () {
  hideAllContent();
  document.querySelector('.Main__Content').classList.add('active');

  var items = [];
  // Product name (used in all)
  var pname = $('.pnameee').attr('data-name');
var selectedIdss = $('.EmbroideryModal__Portal').attr('data-id');
items.push({
   id: selectedIdss,
      quantity: 1,
   });
  /* TEXT SECTION */
  var text_vid = $('.text_datacart').attr('data-vid');
  if (text_vid) {
    items.push({
      id: text_vid,
      quantity: 1,
      properties: {
        Customised_Product: pname,
        First_name: $('.text_datacart').attr('data-first'),
        Second_name: $('.text_datacart').attr('data-last'),
        Text_Position: $('.text_datacart').attr('data-position'),
        Text_Color: $('.text_datacart').attr('data-color'),
        Font_Type: $('.text_datacart').attr('data-font')
      }
    });
  }

  /* ICON SECTION */
  var icon_vid = $('.icon_datacart').attr('data-vid');
  if (icon_vid) {
    items.push({
      id: icon_vid,
      quantity: 1,
      properties: {
        Customised_Product: pname,
        Icon_image: $('.icon_datacart').attr('data-icon'),
        Initials: $('.icon_datacart').attr('data-intial'),
        Initials_Color: $('.icon_datacart').attr('data-intialcolor'),
        Icon_Placement: $('.icon_datacart').attr('data-placement')
      }
    });
  }
  /* LOGO SECTION */
  var logo_vid = $('.logo_datacart').attr('data-vid');
  if (logo_vid) {
    items.push({
      id: logo_vid,
      quantity: 1,
      properties: {
        Customised_Product: pname,
        Logo_image: $('.logo_datacart').attr('data-img'),
        Logo_Color: $('.logo_datacart').attr('data-logocolor'),
        Logo_Placement: $('.logo_datacart').attr('data-placement')
      }
    });
        items.push({
      id: 51936655966522,
      quantity: 1,
      properties: {
        Customised_Product: pname,
      }
    });
  }

  // ✅ Add all items to Shopify cart
  if (items.length > 0) {

fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ items })
})
  .then(response => {
    console.log('heeeloo'+response);
    if (!response.ok) {
      // Force the error to go to catch()
      return response.json().then(err => { throw err });
    }
    return response.json();
  })
  .then(data => {
    handleTextReset();
    // // handleIconReset ();
    handleLogoReset();
    console.log('Added to cart:', data);
    // Optional: redirect or open cart drawer
    location.href = "/cart";
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    alert(error?.description || 'Something went wrong. Please try again.');
  });

  }
});


$(document).on('click','.IconSelector__IconButton',function(){
var img = $(this).find('img').attr('src');
$('.IconPreviewItem__Body img').attr('src',img);
});
$(document).on('click','.iconcolor',function(){
var col = $(this).attr('data-value');
$('.IconPreviewItem__Initials.colorr_black').css('color',col);
});
